import ProfileChangeLogIcon from '@material-ui/icons/ViewList';

import ProfileChangeLogList from './ProfileChangeLogList';

export default {
  list: ProfileChangeLogList,
  icon: ProfileChangeLogIcon,
};
